import React, { useEffect } from "react";
import { EntityId } from "@reduxjs/toolkit";
import { TwitterPicker } from 'react-color';
import { useAppSelector } from "../../../../store/hooks";
import { filterOption } from "../../../../helpers/FormHelper";
import {
  CategoryInterface,
  selectCategoryEntities,
  selectCategoryIds
} from "../../../../store/mine_craft/categoriesSlice";

import { Button, Form, Input, Select} from "antd";
import FileDropzone from "../../../../componets/FileDropzone";

interface propsInterface {
  params?: CategoryInterface | undefined;
  onFinish: Function;
}

const COLORS = [
  '#EA3468',
  '#5D5FEF',
  '#FBA018',
  '#B0EA34',
  '#34EAC9',
];

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();
  const categories = useAppSelector(selectCategoryEntities);
  const categoryIds = useAppSelector(selectCategoryIds);
  const colorValue = Form.useWatch('color', form);
  const titleValue = Form.useWatch('title', form);

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  const renderCategoryOption = (id: EntityId) => {
    const item = categories[id];

    if (!item) {
      return null;
    }

    return <Select.Option key={id} value={id} title={item.title}>{item.title}</Select.Option>
  }

  function handleColorChange(color: any) {
    form.setFieldsValue({ color: color.hex });
  }

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <div className='v-group-dropzone'>
        <FileDropzone name='image' label='Image' preview={params?.image_url} />
      </div>

      <span
        className='v-categories-form--name_preview'
        style={{ borderColor: 'transparent', color: colorValue }}
      >
        <span>{titleValue}</span>
      </span>

      <TwitterPicker
        className='v-mb-15'
        width='100%'
        colors={COLORS}
        color={colorValue}
        onChangeComplete={handleColorChange}
      />

      <Form.Item name='target_id' noStyle>
        <Input type="hidden" />
      </Form.Item>

      <Form.Item name='color' noStyle>
        <Input type='hidden' />
      </Form.Item>

      <Form.Item name='title' label="Title">
        <Input placeholder='Title' />
      </Form.Item>

      <Form.Item name='slug' label="Slug">
        <Input placeholder='Slug' />
      </Form.Item>

      {
        (!params?.subcategories || params?.parent_id || params?.subcategories.length === 0) &&
          <Form.Item
            name='parent_id'
            label="Parent category"
          >
            <Select
              allowClear
              showSearch
              filterOption={filterOption}
              placeholder='Select a parent category'
            >
              {categories && categoryIds.map(renderCategoryOption)}
            </Select>
          </Form.Item>
      }

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
